import styled from 'styled-components';

export const UnitTableWrapper = styled.div`
    overflow-x: ${props => props.mobile && 'scroll'};

    td {
        border-top: 1px solid #c3ccd9;
    }

    td,
    th {
        vertical-align: top;
        line-height: inherit;
        padding: ${props => (props.mobile ? '8px' : '8px 16px')};
    }
`;

export const Cell = styled.td`
    text-align: ${props => props.priceCell && 'right'};
    text-align: ${props => props.centerCell && 'center'};
`;

const getBackgroundColor = props => {
    if (props.isCurrentRow) return '#f1f9ff';
    if (props.useDraftBackgroundColor) return '#ffefef';
    return null;
};

export const TableBodyRow = styled.tr`
    td:nth-of-type(-n + 5) {
        cursor: pointer;
        background-color: ${props =>
            (props.useDraftBackgroundColor || props.isCurrentRow) && getBackgroundColor(props)};
    }

    .floor-plan-cell {
        min-width: 150px;
        padding-right: 0;
    }
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
`;

export const CenterLineRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const BaseLineRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: space-between;
`;
